export default __webpack_public_path__ + "static/media/diagnostic-1.54d35800.svg";